﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListAnfallstelle extends GuiListGeneric {

    constructor() {
        super("Anfallstelle");

    }

}
